import slide1 from 'common/building-blocks/assets/images/slide-1.jpg';
import slide2 from 'common/building-blocks/assets/images/slide-2.jpg';
import { COMPONENT_STATES, COMPONENT_TYPE, DEFAULT_MEDIA_QUERY_PLATFORMS } from 'common/constants';
import { OTHER_PROPS } from 'common/constants/component-props';
import { defaultProps } from './constants';
import { createModel } from '../create-model';
import type { CreatedBuildingBlock } from '../creation-types';

export const visualCompare = (): CreatedBuildingBlock<typeof COMPONENT_TYPE.VISUAL_COMPARE> =>
	createModel({
		type: COMPONENT_TYPE.VISUAL_COMPARE,
		componentProps: {
			styles: {},
			other: {
				[COMPONENT_STATES.DEFAULT]: {
					[DEFAULT_MEDIA_QUERY_PLATFORMS.DEFAULT]: {
						[OTHER_PROPS.visualCompare.visualCompareSrcA]: slide1,
						[OTHER_PROPS.visualCompare.visualCompareSrcB]: slide2,
						[OTHER_PROPS.visualCompare.visualCompareMode]: defaultProps.visualCompareMode,
					},
				},
			},
		},
		children: [],
	}) satisfies CreatedBuildingBlock<typeof COMPONENT_TYPE.VISUAL_COMPARE>;
